module.exports = __webpack_public_path__ + "img/camp06_open.4ca89d30.png";